import { Component, OnInit, Input, inject, DestroyRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Constants } from 'src/app/models/constants';
import { LobService } from 'src/app/services/api/lob.service';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { CustomToastrService } from 'src/app/services/util/toastr.service';

@Component({
    selector: 'app-add-line-of-business',
    templateUrl: './add-line-of-business.component.html',
    styleUrls: ['./add-line-of-business.component.scss'],
    standalone: false
})
export class AddLineOfBusinessComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
  @Input() edit;
  editData: any;

  @Input() set data(data: any) {
    this.editData = data;
  };

  Constants = Constants;
  title: string;
  createLobForm: FormGroup;
  textbutton: string;
  isLoading = false;

  constructor(private formBuilder: FormBuilder, public sidenavService: SidenavService, private dialog: MatDialog,
    private toastrService: ToastrService, private lobService: LobService, private customToastrService: CustomToastrService) {
    
  }

  ngOnInit(): void {
    this.textbutton = translate('LINE_OF_BUSINESS.SUBMIT');
    this.title = translate('LINE_OF_BUSINESS.ADD_NEW_LOB');
    if(this.editData){
      this.textbutton = translate('BUTTONS.UPDATE');
      this.title = translate('LINE_OF_BUSINESS.EDIT_lOB');
    }
    this.createForm();
  }

  getDeployment(): any {
    if (!FormUtilService.validateForm(this.createLobForm)) {
      return;
    }
    return this.createLobForm.getRawValue();
  }

  /**
   * Adds/Edits a LOB to the Line of business list when user clicks on submit button along with the confirmation popup.
   */
  createDeployment(): void {
    if (!this.getDeployment()) {
      return;
    }
    this.isLoading = true;
    if(!this.editData){
      const formData = this.createLobForm.getRawValue();
      const obj = this.getDeployment();
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('LINE_OF_BUSINESS.ADD_TITLE'),
          message:translate('LINE_OF_BUSINESS.ADD_MESSAGE'),
          confirmButtonText: translate('BUTTONS.CONFIRM')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.lobService.postLineOfBusiness(formData)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(data => {
              if (data) {
                this.toastrService.success(translate('ADD_LOB.LOB_ADDED'));
                this.sidenavService.closeRightSidenav(obj);
            setTimeout(() => {
              const title = translate('INSTANCE_STATUS.lineOfBusiness');
              const message = translate('ADD_LOB.LOB_ADDED');
              this.customToastrService.successMessage(message, title);
            }, 500);
              }
            },
            (error) => {
              this.isLoading = false;
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '342px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title:  translate('ERROR_DIALOG.ADD_LINE_OF_BUSINESS_FAILED'),
                  description: errorMessage
                }
              });
            });
          }
        });
    } else {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('LINE_OF_BUSINESS.EDIT_TITLE'),
          message:translate('LINE_OF_BUSINESS.EDIT_MESSAGE'),
          confirmButtonText: translate('BUTTONS.CONFIRM')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            const formData = this.createLobForm.getRawValue();
            const obj = this.getDeployment();
            this.lobService.putLineOfBusiness(formData)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(data => {
              if (data) {
                this.toastrService.success(translate('ADD_LOB.LOB_UPDATED'));
                this.sidenavService.closeRightSidenav(obj);
            setTimeout(() => {
              const title = translate('INSTANCE_STATUS.lineOfBusiness'); 
              const message = translate('ADD_LOB.LOB_UPDATED');
              this.customToastrService.successMessage(message, title);
            }, 500);
              }
            },
            (error) => {
                this.isLoading = false;
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                minHeight: '342px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title:  translate('ERROR_DIALOG.UPDATE_LINE_OF_BUSINESS_FAILED'),
                  description: errorMessage
                }
              });
            });
          }
        });
      }
  }

  createForm(): void {
    const formConfig: any = {
      name: ['', [Validators.required]],
      displayName: ['', [Validators.required]],
      tagline: ['', [Validators.required]],
      imageRef: ['', [Validators.required, Validators.pattern('^(http|https)(.+)(jpg|png)$')]],
      shortDescription: ['', [Validators.required]],
    };
    this.createLobForm = this.formBuilder.group(formConfig);
    const keys = Object.keys(formConfig);
    const values = this.editData;
    if(values){
      keys.forEach(key => {
        this.createLobForm.get(key).setValue(values[key]);
      });
    }
  }

}
